import { twMerge } from 'tailwind-merge';
import clsx from 'clsx';
import { toggleUiTheme, UiTheme } from 'slices/uiTheme';

import { SunIcon } from 'components/Icons/V2/SunIcon';
import { MoonIcon } from 'components/Icons/V2/MoonIcon';

interface ThemeToggleProps {
  theme: UiTheme;
  onToggle: typeof toggleUiTheme;
  lightLabel: string;
  darkLabel: string;
}

export const ThemeToggle = ({ theme, onToggle, lightLabel, darkLabel }: ThemeToggleProps) => {
  return (
    <button
      type="button"
      className={twMerge(
        clsx(
          'group relative flex h-7 w-max items-center gap-x-1 rounded-2xl bg-primary-30',
          'px-2 py-0.5 text-general-100 dark:bg-general-100 dark:text-white'
        )
      )}
      onClick={() => onToggle()}
      data-testid="theme-toggle-button"
    >
      <div
        className={twMerge(
          clsx(
            'flex w-full flex-row-reverse items-center justify-end text-left text-xs font-bold',
            {
              'flex-row justify-start': theme === 'dark'
            }
          )
        )}
        data-testid="theme-toggle-text"
      >
        {theme === 'light' ? lightLabel : darkLabel}
        <div className={clsx('flex size-5 items-center justify-center rounded-full')} />
      </div>
      <div
        className={clsx(
          'absolute flex size-5 items-center justify-center rounded-full bg-white transition-all duration-300',
          {
            'left-1': theme === 'light',
            'left-[calc(100%-1.5rem)]': theme === 'dark' // adjust as needed
          }
        )}
      >
        {theme === 'light' ? (
          <SunIcon data-testid="theme-toggle-light-icon" />
        ) : (
          <MoonIcon data-testid="theme-toggle-dark-icon" />
        )}
      </div>
    </button>
  );
};
